import { useEffect, useRef } from "react";
import { useReducedMotion } from "framer-motion";

const ITEMS = [
    "Infor Solutions",
    "Digital Marketing",
    "Software Development",
    "AI, ML & Generative AI",
    "Ideas. Innovation. Impact.",
    "24×7 Support",
    "Global Delivery",
];

const PALETTE = ["#00F0FF", "#0066FF", "#E6007E", "#7000FF"];

export const Marquee = () => {
    const trackRef = useRef(null);
    const reduce = useReducedMotion();
    const doubled = [...ITEMS, ...ITEMS];

    useEffect(() => {
        if (reduce) return undefined;
        let raf;
        const tick = () => {
            const track = trackRef.current;
            if (track) {
                const cx = window.innerWidth / 2;
                const range = window.innerWidth * 0.28;
                track.querySelectorAll("[data-mq-item]").forEach((el) => {
                    const r = el.getBoundingClientRect();
                    const p = Math.max(0, 1 - Math.abs(r.left + r.width / 2 - cx) / range);
                    el.style.transform = `scale(${(1 + p * 0.32).toFixed(3)})`;
                    el.style.opacity = (0.45 + p * 0.55).toFixed(3);
                    el.style.filter = p > 0.7 ? `drop-shadow(0 0 16px ${el.dataset.color})` : "";
                });
            }
            raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, [reduce]);

    return (
        <div
            className="relative overflow-hidden border-y border-white/5 py-7"
            style={{ background: "rgba(19, 26, 48, 0.5)" }}
            aria-hidden="true"
            data-testid="editorial-marquee"
        >
            <div ref={trackRef} className="marquee-track flex w-max items-center gap-12 whitespace-nowrap">
                {doubled.map((item, i) => (
                    <span key={i} className="flex items-center gap-12">
                        <span
                            data-mq-item
                            data-color={PALETTE[i % 4]}
                            className="inline-block text-lg font-bold tracking-wide sm:text-xl"
                            style={{
                                fontFamily: "Outfit, sans-serif",
                                color: PALETTE[i % 4],
                                willChange: "transform, opacity",
                            }}
                        >
                            {item}
                        </span>
                        <span
                            className="inline-block h-1.5 w-1.5 rotate-45"
                            style={{ background: PALETTE[i % 4] }}
                        />
                    </span>
                ))}
            </div>
            <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0A0F1E] to-transparent" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0A0F1E] to-transparent" />
        </div>
    );
};
